import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import { parse, addDays } from "date-fns";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
import { ReportsModule } from "@/store/modules/report.module";
import { IEntryReportDTO } from "@/store/models/entry/entryExportDTO";
import { interpret } from "xstate";
import entryReportMachine from "../machines/entryReportComponentMachines";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { DateFormatConstant } from "@/store/DateFormatConstants";
import Swal from "sweetalert2";
let EntryReportComponent = /** @class */ (() => {
    var _a;
    let EntryReportComponent = class EntryReportComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.highlightId = null;
            this.reportTemplateId = null;
            this.reportName = "";
            this.dateRangeStart = null;
            this.dateRangeEnd = null;
            this.hasNoReportId = false;
            this.hasPartialDateRange = false;
            this.machine = entryReportMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.gasReportId = "d33f26ce-3ead-4015-855e-3935bb69b59c";
            this.genericReportId = "2033b734-4bae-45d5-a5b3-3a27ff05d2f5";
        }
        send(event) {
            this.machineService.send(event);
        }
        showModal() {
            this.send({ type: "GETTING_HIGHLIGHT_AND_REPORT_TEMPLATE" });
            this.$bvModal.show("showExportOptions");
        }
        selectReport(reportId) {
            // Only PA Gas uses the Last Action Date range, so never carry it across a report change.
            if (this.reportTemplateId !== reportId) {
                this.reportItems.startDate = null;
                this.reportItems.endDate = null;
                this.reportItems.createdStartDate = null;
                this.reportItems.createdEndDate = null;
                this.hasPartialDateRange = false;
            }
            this.reportTemplateId = reportId;
            var name = this.reports.find((x) => x.id == reportId).value;
            const currentDate = new Date();
            var date = this.DateFormatForReportName(currentDate);
            this.reportName = `${name}_${date}`;
        }
        // public DateFormatForReportName(inputDate) {
        //     var year = inputDate.getFullYear().toString();
        //     var month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        //     var day = inputDate
        //         .getDate()
        //         .toString()
        //         .padStart(2, "0");
        //     return `${year}-${month}-${day}`;
        // }
        exportEntriesWithTemplate() {
            if (this.reportTemplateId == null) {
                this.hasNoReportId = true;
                this.reportItems.reportTemplateId = this.reportTemplateId;
            }
            else {
                this.reportItems.reportTemplateId = this.reportTemplateId;
                this.hasNoReportId = false;
            }
            this.reportItems.highlightId = this.highlightId;
            // The created-entries range is optional, but a half-filled range would silently
            // append nothing, so ask for the missing end of it instead.
            this.hasPartialDateRange = !!this.reportItems.createdStartDate !== !!this.reportItems.createdEndDate;
            if (this.hasPartialDateRange) {
                return;
            }
            this.validate("entryReportObserver").then((response) => {
                if (response) {
                    this.send({
                        type: "EXPORTING_ENTRIES",
                        entryReport: this.reportItems,
                        reportName: this.reportName,
                    });
                }
            });
        }
        close() {
            this.hasNoReportId = false;
            this.hasPartialDateRange = false;
            this.emptyReportPrams();
            this.$bvModal.hide("showExportOptions");
        }
        emptyReportPrams() {
            this.highlightId = null;
            this.reportTemplateId = null;
            this.reportItems.highlightId = null;
            this.reportItems.reportTemplateId = null;
            this.reportItems.endDate = null;
            this.reportItems.startDate = null;
            this.reportItems.createdEndDate = null;
            this.reportItems.createdStartDate = null;
        }
        disableLastActionStart(date) {
            if (!this.reportItems.endDate)
                return false;
            const endDate = parse(this.reportItems.endDate, this.inputDateFormat, new Date());
            const startDateLimit = addDays(endDate, -60);
            return date < startDateLimit || date > endDate;
        }
        disableLastActionEnd(date) {
            if (!this.reportItems.startDate)
                return false;
            const startDate = parse(this.reportItems.startDate, this.inputDateFormat, new Date());
            const endDateLimit = addDays(startDate, 60);
            return date > endDateLimit || date < startDate;
        }
        disableCreatedOnStart(date) {
            if (!this.reportItems.createdEndDate)
                return false;
            return date > parse(this.reportItems.createdEndDate, this.inputDateFormat, new Date());
        }
        disableCreatedOnEnd(date) {
            if (!this.reportItems.createdStartDate)
                return false;
            return date < parse(this.reportItems.createdStartDate, this.inputDateFormat, new Date());
        }
        get inputDateFormat() {
            return this.dateFormat === DateFormatConstant.DateFormat.DateFormatDMY() ? DateFormatConstant.DateFormatClientDMY() : DateFormatConstant.DateFormatClientMDY();
        }
        get isGasReport() {
            return this.gasReportId === this.reportTemplateId;
        }
        get reports() {
            return ReportsModule.reportsTemplate;
        }
        get highLights() {
            return ReportsModule.hightLights;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("modalDormant")) {
                    this.close();
                }
                if (this.state.hasTag("serviceUnavailable")) {
                    Swal.fire({
                        title: "The page encountered an error.",
                        text: `Please click 'OK' to refresh the page.`,
                        icon: "warning",
                        confirmButtonText: "OK",
                    }).then((result) => {
                        window.location.reload();
                    });
                }
            });
        }
        destroyed() {
            this.emptyReportPrams();
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IEntryReportDTO !== "undefined" && IEntryReportDTO) === "function" ? _a : Object)
    ], EntryReportComponent.prototype, "reportItems", void 0);
    EntryReportComponent = __decorate([
        Component({
            name: "EntryReportComponent",
            components: {
                simplebar,
                SectionLoader,
            },
        })
    ], EntryReportComponent);
    return EntryReportComponent;
})();
export default EntryReportComponent;
